'use strict'

module.exports = Schema

var proto = Schema.prototype

proto.space = null
proto.normal = {}
proto.property = {}

function Schema(property, normal, space) {
  this.property = property
  this.normal = normal

  if (space) {
    this.space = space
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/rehype-react/~/property-information/lib/util/schema.js
// module id = 426
// module chunks = 35783957827783 241767136424496